import { ReactNode } from 'react'
import { Border, BoxConstraints, PaintOp, RenderBox } from '../rendering'
import { renderElement } from '../document'

type Props = {
  backgroundColor?: string
  border?: Border
}

export class DecoratedRenderBox extends RenderBox<Props> {
  performLayout(constraints: BoxConstraints) {
    const child = this.children[0]

    if (child) {
      child.performLayout(constraints)
    }

    this.box = child
      ? { x: 0, y: 0, width: child.box.width, height: child.box.height }
      : { x: 0, y: 0, width: constraints.minWidth, height: constraints.minHeight }
  }

  draw(): PaintOp {
    const rect: PaintOp = {
      type: 'rect',
      bounds: { x: 0, y: 0, width: this.box.width, height: this.box.height },
      border: this.props.border,
      background_color: this.props.backgroundColor
    }

    return {
      type: 'group',
      bounds: this.box,
      children: [rect, ...this.children.map((c) => c.draw())]
    }
  }
}

export function Decorated({ backgroundColor, border, children }: Props & { children?: ReactNode }) {
  return renderElement(new DecoratedRenderBox({ backgroundColor, border }), children)
}
